import { gql } from "apollo-boost"

export const specificObjectivesBySubmissionQuery = gql`
  query SpecificObjectivesBySubmission($id: ID!) {
    SpecificObjectivesBySubmission(id: $id) {
      id
      orderIndex
      description
      indicators {
        id
        isBlocking
        goal
        type
        title
        endDate
        startDate
        orderIndex
        description
        meansOfVerification
      }
      activities {
        id
        isBlocking
        goal
        title
        orderIndex
        description
        responsible
        meansOfVerification
        schedules {
          id
          place
          scheduledAt
          completedAt
          startTime
          endTime
        }
      }
    }
  }
`